var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer_service"},[_c('div',{staticClass:"customer_service_inner"},[_c('nuxt-child')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }